<template>
  <blockquote class="c-quote quote">
    <q v-html="data.content" />
  </blockquote>
</template>

<script>
export default {
  name: 'AppQuote',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.quote {
  font-family: $font-family-text;
  font-size: 20px;
  font-weight: 300;
  margin: 50px 0;

  @include mq(ipadP) {
    font-size: 24px;
  }
}
</style>
